import { render, staticRenderFns } from "./Size.vue?vue&type=template&id=21d97b7c&scoped=true&"
import script from "./Size.vue?vue&type=script&lang=js&"
export * from "./Size.vue?vue&type=script&lang=js&"
import style0 from "../assets/less/filters.less?vue&type=style&index=0&id=21d97b7c&lang=less&scoped=true&"
import style1 from "./Size.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d97b7c",
  null
  
)

export default component.exports